import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const navigationDiscardChangesPromptEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-navigation-discard-changes-prompt" */ './index'),
	),
	getPreloadProps: () => ({}),
});
